module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/206-rwanda-c379c0ebf0cdc53f2f213f774d38b17a.svg";